import * as React from 'react'
import { Helmet } from 'react-helmet'

// import WaveContainer from "../../components/wave-container";
import DooerLive from '../../sections/dooer-live'
import Footer from '../../sections/footer'

import Hero from './components/hero'
// import Pong from "./components/pong";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>{'404 Sidan finns inte | Dooer'}</title>
      </Helmet>

      <Hero />
      {/* <WaveContainer>
        <Pong />
      </WaveContainer> */}
      <DooerLive inverted />
      <Footer />
    </>
  )
}
